<template>
    <div class="animated fadeIn">
        <b-row class="mb-2">
            <b-col class="text-right">
                <b-button  v-if="Core.Session.AuthUser.can('binder_management_post') && dataBinderTemplate.addNewLabel !== ''" @click="add" class="btn btn-light">{{dataBinderTemplate.addNewLabel}}</b-button>
            </b-col>
        </b-row>
        <DynamicCardList
                v-if="dataBinderTemplate !== false && Core.Validation.isId(dataBinderTemplate.id)"
                ref="dynamicCardList"
                :caption="dataBinderTemplate.listLabel"
                :searchFormStructure="dataSearchFormStructure"
                :columns="dataColumns"
                :edit="dataEdit"
                :onRetrieve="onRetrieve"
                @onRequestSuccess="onRequestSuccess"
                root="/binder/list"
                :trash="dataTrash">
        </DynamicCardList>
        <ModalTrash
                ref="trash"
                root="/binder"
                @onTrashSuccess="onTrashSuccess"
                :caption="Core.Definition.getDefinition('Suppression de l\'entrée')"
                :message="Core.Definition.getDefinition('Êtes-vous sûr de vouloir supprimer cette entrée?')"></ModalTrash>
    </div>
</template>

<script>
    import DynamicCardList from '../../components/DynamicCardList'
    import ModalTrash from '../../components/ModalTrash'
    export default {
        name: 'BinderInstanceList',
        components: {
            DynamicCardList,
            ModalTrash
        },
        watch: {
            dataSlug(val) {
                let binderTemplate = Core.Array.findByKey(Core.Session.binders, 'slug', val)
                if (binderTemplate) {
                    this.dataBinderTemplate = binderTemplate
                }
            }
        },
        mounted() {
            if (this.$route.params !== undefined) {
                if (this.$route.params.slug !== undefined) {
                    this.dataSlug = this.$route.params.slug
                }
            }
        },
        data: function () {
            return {
                Core: window.Core,
                dataSlug: '',
                dataBinderTemplate: false,
                dataColumns: [],
                dataSearchFormStructure: {
                },
                dataEdit: {
                    show: true,
                    text: '<button class="btn btn-sm btn-info"><i class="fa fa-edit"></i></button>',
                    onClick:  this.clickEdit
                },
                dataTrash: {
                    show: true,
                    text: '<button class="btn btn-sm btn-danger"><i class="fa fa-trash"></i></button>',
                    onClick: this.clickTrash
                }
            }
        },
        methods: {
            onRetrieve() {
                this.$refs.dynamicCardList.$refs.request.addArg('binderTemplateId', this.dataBinderTemplate.id)
            },
            onRequestSuccess(data) {
                if(data.columns !== undefined) {
                    this.dataColumns = data.columns
                }
            },
            add() {
                this.$router.push(this.dataBinderTemplate.addNewUrl)
            },
            clickEdit(value, cell, row) {
                this.$router.push(this.dataBinderTemplate.url + '/' + row.id)
            },
            clickTrash(value, cell, row) {
                this.$refs.trash.open(row.id)
            },
            onTrashSuccess() {
                this.$refs.dynamicCardList.retrieve()
            }
        }
    }
</script>
